// components/ConfirmAlert.js
import Swal from 'sweetalert2';

const showConfirm = async (message = "¿Estás seguro que desea eliminar este registro?", confirmButtonText = "Sí", cancelButtonText = "Cancelar") => {
    const result = await Swal.fire({
        title: 'Confirmación',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText,
        cancelButtonText
    });

    return result.isConfirmed;
};

export default showConfirm;
